import * as actionTypes from '../actions/actionTypes';

let initialState = {
    isShowSidebar: false,
    lang: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TOGGLE_SIDEBAR:
            return {
                ...state,
                isShowSidebar: !state.isShowSidebar
            };
        case actionTypes.CLOSE_SIDEBAR:
            return {
                ...state,
                isShowSidebar: false
            };
        case actionTypes.SET_LANG:
            return {
                ...state,
                lang: action.lang
            };

        default:
            return state;
    }
};

export default reducer;